import { useContextState } from "../../hooks/theme"

const useStyles = () => {
    const { colors } = useContextState()

    return {
        container: {
            '& a': {
                color: colors.color13,
                textDecoration: 'none'
            },
            '& .home': {
                padding: '4px',
                '& .MuiSvgIcon-root': {
                    fontSize: '20px'
                }
            },
            '& .active': {
                color: colors.color33,
                fontWeight: 'semi-bold'
            },
            '& .MuiButton-root': {
                color: colors.color13,
                background: 'none'
            }
        },
        link: {
            color: colors.color13,
        },
        rootPathContainer: {
            display: 'flex',
            width: '100%',
            alignItems: 'center',
            gap: 2,
            justifyContent: 'space-between'
        }
    }
}

export { useStyles }
